module.exports = __webpack_public_path__ + "img/flower-hero.adcd0314.svg";